import jsonp from "@util/jsonp"
import Http from "../util/httpUtils"
import { API, JD_API } from "../constants/conf"

export const logout = async (platform: string) => {
  try {
    const result = await Http.get(`${API}/oauth/signOut`, { platform })
    return result
  } catch (error) {
    console.log(`Dragon: logout -> error`, error)
  }
}

export const jdLogout = async () => {
  try {
    return await jsonp(`${JD_API}/logout`)
  } catch (error) {}
}

export const getToken = async (
  code: string,
  platform?: string,
  redirectUri?: string
) => {
  try {
    const result = Http.get(`${API}/oauth/get_token`, {
      code,
      platform,
      redirectUri
    })
    return result
  } catch (error) {
    console.log(`Dragon: error`, error)
  }
}
